export default __webpack_public_path__ + "static/media/part_3_con_01.bc150131.gif";